import { render, staticRenderFns } from "./editUpdateDescription.vue?vue&type=template&id=658237d6&scoped=true&"
import script from "./editUpdateDescription.vue?vue&type=script&lang=js&"
export * from "./editUpdateDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658237d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VSheet})
